import React from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = user?.role === 'admin' || user?.accountType === 'admin';

  const isActive = path => location.pathname === path || location.pathname.startsWith(`${path}/`);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (err) {
      console.error('Logout failed', err);
    }
  };

  return (
    <div className="pro-dashboard">
      <header className="pro-topbar">
        <div className="pro-topbar-inner">
          <Link className="pro-brand" to={isAdmin ? '/admin/lms' : '/student/dashboard'}>
            FinExperts LMS
          </Link>
          <nav className="pro-topnav">
            <ul>
              <li>
                <NavLink to={isAdmin ? '/admin/lms' : '/student/dashboard'}>Dashboard</NavLink>
              </li>
              <li>
                <NavLink to={isAdmin ? '/admin/courses' : '/courses'}>Analytics</NavLink>
              </li>
              <li>
                <NavLink to={isAdmin ? '/admin/lms-enrollments' : '/student/dashboard'}>
                  Reports
                </NavLink>
              </li>
            </ul>
          </nav>
          <div className="pro-actions">
            {isAdmin ? (
              <Link className="pro-cta" to="/admin/courses/create">
                + New Course
              </Link>
            ) : (
              <Link className="pro-cta" to="/courses">
                Browse Courses
              </Link>
            )}
            <button className="pro-logout" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="pro-body">
        <aside className="pro-sidebar">
          <div className="pro-sidebar-title">Navigation</div>
          <ul className="pro-menu">
            {/* For regular users: show courses and enrollments */}
            {(!user || !isAdmin) && (
              <>
                <li>
                  <NavLink to="/student/dashboard">Dashboard</NavLink>
                </li>
                <li>
                  <NavLink to="/courses">Courses</NavLink>
                </li>
                {user && (
                  <li>
                    <NavLink to="/student/dashboard">My Enrollments</NavLink>
                  </li>
                )}
              </>
            )}

            {/* Admin sidebar: full management links */}
            {user && isAdmin && (
              <>
                <li>
                  <NavLink to="/admin/lms">Dashboard</NavLink>
                </li>
                <li className="pro-section">Admin</li>
                <li>
                  <NavLink to="/admin/courses">Manage Courses</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/courses/create">Create Course</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/lms-enrollments">Enrollments</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/users">User Management</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/superadmin">Super Admin</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/company">Company</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/services">Footer Services</NavLink>
                </li>
                <li>
                  <NavLink to="/articles/new">Create Article</NavLink>
                </li>
                <li>
                  <NavLink to="/gallery-admin">Manage Gallery</NavLink>
                </li>
                {isActive('/admin/courses/edit') && <li><span className="pro-menu-active">Editing Course</span></li>}
              </>
            )}
          </ul>
        </aside>

        <main className="pro-content">{children}</main>
      </div>

      <footer className="pro-footer">
        © {new Date().getFullYear()} Financial Experts — Dashboard
      </footer>
    </div>
  );
};

export default DashboardLayout;
